<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.faq") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #EF3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Ar Content Text Editor -->
          <v-container>
            <v-row
              v-for="(box, index) in boxes"
              :key="index"
              class="mb-6"
              align="center"
            >
             <v-col cols="12" class="text-right">
                <v-btn icon color="primary" @click="addBox">
                  <i class="fas fa-plus"></i>
                </v-btn>

                <v-btn
                  icon
                  color="red"
                  v-if="boxes.length > 1"
                  @click="removeBox(index)"
                >
                  <i class="fas fa-minus"></i>
                </v-btn>
              </v-col>
              <base-input
                col="6"
                rows="3"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.question_ar')"
                v-model="box.question_ar"
                required
              />
              <base-input
                col="6"
                rows="3"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.question_en')"
                v-model="box.question_en"
                required
              />
              <base-input
                col="6"
                rows="3"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.answer_ar')"
                v-model="box.answer_ar"
                required
              />
              <base-input
                col="6"
                rows="3"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.answer_en')"
                v-model="box.answer_en"
                required
              />
              <v-divider class="my-4"></v-divider>
            </v-row>
          </v-container>
          <!-- End:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "AboutUs",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      boxes: [
        {
          question_ar: "",
          question_en: "",
          answer_ar: "",
          answer_en: "",
        },
      ],
      // Start:: Data Collection To Send
      data: {
        contentAr: null,
        contentEn: null,
        nameAr: null,
        nameEn: null,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    addBox() {
      this.boxes.push({
        question_ar: "",
        question_en: "",
        answer_ar: "",
        answer_en: "",
      });
    },
    removeBox(index) {
      if (this.boxes.length > 1) {
        this.boxes.splice(index, 1);
      }
    },
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `settings?key=faq`,
        });
        // Start:: Set Data
        if (res.data.data.data[0].value) {
          this.boxes = res.data.data.data[0].value?.map((item) => ({
            question_ar: item.question.ar,
            question_en: item.question.en,
            answer_ar: item.answer.ar,
            answer_en: item.answer.en,
          }));
        } else {
          this.boxes = [
            {
              question_ar: "",
              question_en: "",
              answer_ar: "",
              answer_en: "",
            },
          ];
        }
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("key", "faq");
      this.boxes.forEach((element, index) => {
        REQUEST_DATA.append(
          `value[${index}][question][ar]`,
          element.question_ar
        );
        REQUEST_DATA.append(
          `value[${index}][question][en]`,
          element.question_en
        );
        REQUEST_DATA.append(`value[${index}][answer][ar]`, element.answer_ar);
        REQUEST_DATA.append(`value[${index}][answer][en]`, element.answer_en);
      });
      // REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `settings`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
